import { render, staticRenderFns } from "./AppCollapseItem.vue?vue&type=template&id=168c9078&"
import script from "./AppCollapseItem.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./AppCollapseItem.vue?vue&type=style&index=0&id=168c9078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports